import { useState } from "react";
import axios from "axios";
import { toast } from "@/components/ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ buttonLabel, testidPrefix, centered = false }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("loading");
    try {
      await axios.post(`${API}/waitlist`, { name, email });
      setStatus("done");
      toast.success("You're on the runloft waitlist.");
    } catch (err) {
      setStatus("idle");
      const detail = err?.response?.data?.detail;
      const message =
        typeof detail === "string"
          ? detail
          : "Something went wrong. Please try again.";
      setError(message);
      toast.error(message);
    }
  };

  if (status === "done") {
    return (
      <div
        data-testid={`${testidPrefix}-success`}
        className={`rounded border border-[#22c55e]/40 bg-[#22c55e]/10 px-4 py-3 font-mono text-xs text-[#22c55e] ${centered ? "mx-auto max-w-md" : "max-w-md"}`}
      >
        <span className="text-[#64748b]">$</span> invite queued for{" "}
        <span className="text-white">{email}</span>
        <span className="ml-2 text-[#22c55e]">✓ confirmed</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      data-testid={`${testidPrefix}-form`}
      className={`flex flex-col gap-3 sm:flex-row ${centered ? "mx-auto max-w-md" : "max-w-md"}`}
      noValidate={false}
    >
      <input
        type="text"
        required
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Developer Name"
        aria-label="Developer Name"
        data-testid={`${testidPrefix}-name-input`}
        className="rounded border border-[#1e293b] bg-[#131b26] px-4 py-3 text-sm text-white placeholder-[#64748b] transition-colors focus:border-[#22d3ee] focus:outline-none"
      />
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="dev@domain.com"
        aria-label="Developer Email"
        data-testid={`${testidPrefix}-email-input`}
        className="rounded border border-[#1e293b] bg-[#131b26] px-4 py-3 text-sm text-white placeholder-[#64748b] transition-colors focus:border-[#22d3ee] focus:outline-none"
      />
      <button
        type="submit"
        disabled={status === "loading"}
        data-testid={`${testidPrefix}-submit-button`}
        className="cursor-pointer whitespace-nowrap rounded bg-[#22d3ee] px-6 py-3 text-sm font-semibold text-[#090d12] transition-colors hover:bg-[#67e8f9] disabled:cursor-wait disabled:opacity-60"
      >
        {status === "loading" ? "Queuing…" : buttonLabel}
      </button>
      {error && (
        <p data-testid={`${testidPrefix}-error`} className="font-mono text-xs text-[#ef4444] sm:col-span-3">
          {error}
        </p>
      )}
    </form>
  );
};
